
// tremor
import { Bold, Table, TableBody, TableCell, TableHead, TableHeaderCell, TableRow, Text } from '@tremor/react';

const TremorTable = (props) => {

    return (
        <Table marginTop='mt-2.5'>
            
            <TableHead>
                <TableRow>
                    { props.headers != undefined && props.headers.map != undefined && props.headers.map((value) => (
                        <TableHeaderCell><Text><Bold>{value}</Bold></Text></TableHeaderCell>
                    ))}
                </TableRow>
            </TableHead>

            <TableBody>
                { props.data != undefined && props.data.map != undefined && props.data.map((value) => (
                    <TableRow>
                        <TableCell><Text truncate={true}>{value}</Text></TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default TremorTable;
